/**
 * MethodScript Core Types
 *
 * Pure TypeScript type definitions with no editor dependencies.
 * These types are designed to be editor-agnostic.
 */

/**
 * SI prefix information
 */
export type SIPrefix = {
    /**
     * Prefix symbol (e.g., 'm', 'k', 'M')
     */
    symbol: string;

    /**
     * Full name (e.g., 'milli', 'kilo', 'mega')
     */
    name: string;

    /**
     * Exponent (e.g., -3 for milli, 3 for kilo)
     */
    exponent: number;
};

/**
 * All SI prefixes used in MethodScript
 */
export const SI_PREFIXES: Record<string, SIPrefix> = {
    a: { symbol: 'a', name: 'atto', exponent: -18 },
    f: { symbol: 'f', name: 'femto', exponent: -15 },
    p: { symbol: 'p', name: 'pico', exponent: -12 },
    n: { symbol: 'n', name: 'nano', exponent: -9 },
    u: { symbol: 'u', name: 'micro', exponent: -6 },
    m: { symbol: 'm', name: 'milli', exponent: -3 },
    k: { symbol: 'k', name: 'kilo', exponent: 3 },
    M: { symbol: 'M', name: 'mega', exponent: 6 },
    G: { symbol: 'G', name: 'giga', exponent: 9 },
    T: { symbol: 'T', name: 'tera', exponent: 12 },
    P: { symbol: 'P', name: 'peta', exponent: 15 },
    E: { symbol: 'E', name: 'exa', exponent: 18 },
};
